import { Injectable } from '@angular/core';
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class TfScriptLoaderService {

    private loaded: string[] = [];

    loadScript(url: string): Observable<boolean> {

        return new Observable<boolean>((subscriber) => {

            const done = () => {
                subscriber.next(true);
                subscriber.complete();
            }

            if (this.loaded.indexOf(url) === -1) {
                this._loadScript(url, () => {
                    this.loaded.push(url);
                    done();
                });
            } else {
                done();
            }

        });

    }

    loadCSS(url: string): Observable<boolean> {

        return new Observable<boolean>((subscriber) => {

            const done = () => {
                subscriber.next(true);
                subscriber.complete();
            }

            if (this.loaded.indexOf(url) === -1) {
                this._loadCSS(url, () => {
                    this.loaded.push(url);
                    done();
                });
            } else {
                done();
            }

        });

    }

    private _loadScript(src, onLoad) {
        const script = document.createElement('script');
        script.src = src;
        script.onload = onLoad;
        document.head.appendChild(script);
    }

    private _loadCSS(url, onLoad) {

        // var cssId = 'myCss';  // you could encode the css path itself to generate id..
        // if (!document.getElementById(cssId))
        // {
        const link = document.createElement('link');
        // link.id   = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        link.media = 'all';
        link.onload = onLoad;
        document.head.appendChild(link);

        // }

    }

}
